import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export enum SNACK_TYPE {
  success = 'green-success-snackbar',
  warning = 'orange-warning-snackbar',
  error = 'red-error-snackbar',
  default = 'default-snackbar',
}

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  public showSnackBar(context: string, message: string) {
    this.snackBar.open(message, '', {
      duration: 2500,
      panelClass: [context || SNACK_TYPE.default],
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    });
  }

  public showErrorMessage(message: string) {
    this.showSnackBar(SNACK_TYPE.error, message);
  }

  public showSuccessMessage(message: string) {
    this.showSnackBar(SNACK_TYPE.success, message);
  }

  public showWarningMessage(message: string) {
    this.showSnackBar(SNACK_TYPE.warning, message);
  }

  public showDefaultMessage(message: string) {
    this.showSnackBar(SNACK_TYPE.default, message);
  }
}
